'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var createUnsubscribe = function createUnsubscribe(options, subsTracker) {
  function unsubscribe(_x, _x2) {
    return _unsubscribe.apply(this, arguments);
  }

  function _unsubscribe() {
    _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, handler) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subsTracker.unsubscribe(topic, handler);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _unsubscribe.apply(this, arguments);
  }

  return unsubscribe;
};

exports.createUnsubscribe = createUnsubscribe;